var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logout-btn"},[_c('a',{staticClass:"btn btn-primary",attrs:{"href":"#!"},on:{"click":function($event){return _vm.logout()}}},[_vm._v("Logout "),_c('i',{staticClass:"bi bi-box-arrow-right ml-2"})])])}
var staticRenderFns = []

export { render, staticRenderFns }